<!-- Single error message -->
<ng-container *ngIf="(!is_array(message))">
    <mat-list class="alert alert-danger mt-3" *ngIf="message && message != ''">
        <div class="error-content">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <span class="error-text" *ngIf="!html">{{ message }}</span>
            <span class="error-text" *ngIf="html" [innerHTML]="message"></span>
        </div>
    </mat-list>
</ng-container>

<!-- Multiple error messages -->
<ng-container *ngIf="this.message && is_array(this.message) && objLength(this.message) > 0">
    <mat-list class="alert alert-danger mt-3" *ngIf="message && message != ''">
        <div class="error-content">
            <mat-icon class="error-icon">error_outline</mat-icon>
            <ul class="error-list">
                <li *ngFor="let m of message">
                    <span>{{ m }}</span>
                </li>
            </ul>
        </div>
    </mat-list>
</ng-container>
